import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'
import useUpdateMode from '../../hooks/useUpdateMode'
import { saveAnswer } from '../../utils/onboardingStorage'

const QUESTION_KEY = 'vibe'

export default function VibePage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const { isUpdate, postToReactNative } = useUpdateMode()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const formAnswer = formData.get('answer') as string

    const answer = {
      question_key: QUESTION_KEY,
      question: "What's the vibe you're going for?",
      answer_key: formAnswer.toLowerCase(),
      answer: formAnswer,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(formData, { method: 'post' })
    }
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.vibe.heading')}
      buttons={[
        {
          text: `💞 ${t('pages.onboarding.vibe.options.romanticSpark')}`,
          value: 'romanticSpark',
        },
        {
          text: `🤝 ${t('pages.onboarding.vibe.options.genuineFriendship')}`,
          value: 'genuineFriendship',
        },
        {
          text: `🕵️ ${t('pages.onboarding.vibe.options.meetNewPeople')}`,
          value: 'meetNewPeople',
        },
        {
          text: `🎉 ${t('pages.onboarding.vibe.options.pureFun')}`,
          value: 'pureFun',
        },
      ]}
      onSubmit={onSubmit}
      headingSize="text-3xl"
      buttonTextSize="text-base"
      buttonBgColor="bg-white"
    />
  )
}
